import { ApiClient } from "@repo/api-client";
import { baseURL } from "@repo/helpers";
import { Language } from "@repo/i18n";

export const apiClient = (language: Language) =>
  new ApiClient(baseURL(), language);
